<content-panel>
  <panel-header heading="{{ panelHeading }}">
    <div>
      <button mat-button (click)="onCancel()">
        <mat-icon class="cancel-button">close</mat-icon>
      </button>
      <button
        mat-button
        (click)="onSave()"
        class="save-button"
        [disabled]="!allRequired || checkForEmptyZone()"
      >
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </panel-header>

  <panel-body>
    <div cdkDropListGroup class="content-container">
      <div class="station-container">
        <div class="container">
          <div class="top-items">
            <div class="heading">{{ panelTitle }}</div>
            @if (stationList?.length !== 0) {
              <mat-icon matTooltip="{{ warningTooltip }}" class="warning-icon"
                >info</mat-icon
              >
            }
          </div>
        </div>
        <div class="panel-body">
          @if (stationList?.length === 0) {
            <div class="all-stations-text">{{ allStationsInUse }}</div>
          } @else {
            <div
              class="item-list"
              [cdkDropListSortingDisabled]="true"
              cdkDropList
              [cdkDropListData]="stationList"
            >
              @for (station of stationList; track station) {
                <div class="item-box" cdkDrag [cdkDragData]="station">
                  <div class="item-name-text" style="max-width: 350px">
                    {{ station.Name }}
                  </div>
                  <div class="item-icons">
                    <div>
                      {{ formatItemCount(station.InspectionTasks.length) }}
                    </div>
                    <mat-icon>menu</mat-icon>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="setup-container">
        <div class="new-zone-container">
          <button class="zone-button" (click)="addZone()">
            {{ addZoneBtnText }}
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>
        @if (zoneList.length > 0) {
          <div class="setup-window">
            @for (targetList of zoneList; track targetList) {
              <div
                class="setup-list"
                cdkDropList
                [cdkDropListData]="targetList.Stations"
                (cdkDropListDropped)="drop($event)"
              >
                <div class="zone-section">
                  <mat-expansion-panel
                    (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false"
                    [expanded]="true"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="zone-heading-text">
                          {{ targetList.Name }}
                        </div>
                        <div class="item-count-text-header">
                          {{ displayTotalItemCount(targetList.Stations) }}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @if (targetList?.Stations?.length === 0) {
                      <div class="setup-list-empty">
                        {{ emptyStationAreaText }}
                      </div>
                    } @else {
                      <div class="setup-area">
                        @for (station of targetList.Stations; track station) {
                          <div
                            class="item-box-setup"
                            style="border-radius: 4px"
                            cdkDrag
                            [cdkDragData]="station"
                          >
                            <div class="setup-item">
                              <mat-icon style="padding-right: 45px"
                                >menu</mat-icon
                              >
                              <div class="setup-list-name">
                                <div class="station-name-text">
                                  {{ station.Name }}
                                </div>
                                <div class="item-count-text">
                                  {{
                                    formatItemCount(
                                      station?.InspectionTasks?.length
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                            <button
                              class="remove-station-button"
                              (click)="removeStation(station)"
                            >
                              <mat-icon
                                style="
                                  height: 25px;
                                  width: 25px;
                                  font-size: 25px;
                                "
                                >close</mat-icon
                              >
                            </button>
                          </div>
                        }
                      </div>
                    }
                  </mat-expansion-panel>
                  @if (targetList.Name !== managerWalk) {
                    <button
                      class="remove-button"
                      (click)="deleteZone(targetList)"
                      [disabled]="targetList.Stations?.length > 0"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  } @else {
                    <button class="mw-button" disabled>
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="edit-mode-container" style="padding-top: 155px">
            <span class="empty-text">{{ this.emptyZoneText1 }}</span>
            <div class="empty-text">-</div>
            <span class="empty-text">{{ this.emptyZoneText2 }}</span>
          </div>
        }
      </div>
    </div>
  </panel-body>
</content-panel>
